import { useMutation, useQueryClient } from '@tanstack/react-query'
import { bulkUpdatePlanAndRateStatusByIds } from '../../../api/plan-and-rate-override-rules-api'
import type { BulkUpdatePlanAndRateStatusByIdsRequestDto } from '../../../api/dto/plan-and-rate-override-rules.dto'
import { PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanAndRateOverride/hooks/useGetPlanAndRateOverrideRules'

export function useBulkUpdatePlanAndRateStatusByIds() {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, BulkUpdatePlanAndRateStatusByIdsRequestDto>(
    {
      mutationFn: (body) => bulkUpdatePlanAndRateStatusByIds(body),
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: [PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY],
        })
      },
    }
  )
}
